@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.toggler-chevron(@width: 10px, @height: 28px) {
  width: @width;
  height: @height;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 8px;
  }

  &.open {
    > svg {
      transform: rotate(-180deg);
    }
  }
}

.drop-down-menu-button-BJGpWko {
  border-radius: 0 3px 3px 0;
  height: 100%;

  svg {
    color: var(--white);
  }

  &:disabled {
    svg {
      color: var(--gray-8D9196);
    }
  }
}

.dropdown-menu-toggler {
  text-align: left;
  max-width: 100%;
  display: flex;
  min-height: 25px;
  padding-right: 0;
  align-items: center;
  justify-content: center;
  position: relative;
  width: inherit;
  min-width: inherit;

  &:global(.button-primary) {
    border-radius: 0 3px 3px 0;
    height: 100%;

    svg {
      color: var(--white);
    }

    &:disabled {
      svg {
        color: var(--gray-8D9196);
      }
    }
  }

  &.childless {
    padding: 0;
  }

  &.link,
  &.danger-link {
    .dropdown-toggler-content {
      line-height: 1.2;
    }

    .dropdown-toggler-chevron {
      .toggler-chevron();
      margin: 0 5px 0 3px;
    }
  }

  &.has-error {
    border: solid 1px @dropdown-menu-toggler--error--border-color;
  }

  &.simple {
    background-color: @dropdown-menu-toggler--background-color;
    border: 1px solid @dropdown-menu-toggler--border-color;
    border-radius: 5px;
    font-size: 14px;
    padding: 8px;
    color: var(--default--text-color--12);

    &.has-error {
      border: solid 1px @dropdown-menu-toggler--error--border-color;

      .dropdown-toggler-content {
        color: @dropdown-menu-toggler--error--text-color !important;
      }
    }

    &:focus,
    &:focus-within {
      border-color: @dropdown-menu-toggler--focus--border-color;
      box-shadow: none;
    }

    &:hover {
      box-shadow: none;

      svg {
        color: inherit;
      }
    }

    .dropdown-toggler-chevron {
      height: 16px;
      margin-right: 0;
      width: 16px;
    }

    svg {
      color: @dropdown-menu-toggler--icon-color;
    }
  }
}

.dropdown-toggler-content {
  .truncate();
  line-height: 1.2;
  width: 100%;
  max-width: 100%;
}

.dropdown-toggler-chevron {
  .toggler-chevron();
  margin: 0 9px;
}

.required-indicator {
  position: absolute;
  top: -1px;
  right: 0;
}
